import {
  View,
  Text,
  StyleSheet,
  TextInput,
  TouchableOpacity,
  ScrollView,
  Button,
  Platform,
  Modal,
  ActivityIndicator,
  PixelRatio,
  Dimensions,
} from "react-native";
import React, { useEffect, useState } from "react";
import Colours from "../../utils/Colours";
import axios from "../../api/axios";
import { useQuery } from "@tanstack/react-query";
import BackArrow from "../../icons/BackArrow";
import AppTextInput from "../../utils/ColourThemes/AppTextInput";
import { CommonActions, useNavigation, useRoute } from "@react-navigation/native";
import SuccessAlertComp from "../../alertComp/SuccessAlertComp";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Image } from "expo-image";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const UsernameDisplaynameScreen = () => {
  const [isUsernameFocused, setIsUsernameFocused] = useState(false);
  const [isDisplaynameFocused, setIsDisplaynameFocused] = useState(false);
  // const [isProfilePhotoFocused, setIsProfilePhotoFocused] = useState(false);

  const [isUsernameValid, setIsUsernameValid] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [isSuccessAlertCompVisible, setIsSuccessAlertCompVisible] = useState(false);
  const [errorMessage2, setErrorMessage2] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [username, setUsername] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [displayname, setDisplayname] = useState("");

  const [searchQueryDebounced, setSearchQueryDebounced] = useState("");
  const [isTyping, setIsTyping] = useState(false);

  // const [namesObjData, setNamesObjData] = useState({})

  const route = useRoute();
  // const newUserData = route.params.newUserData;
  // const image = newUserData.newUser.profilePicture;
  // const userID = newUserData.newUser._id;

  const userDataObj = route.params.userDataObj;
  const image = userDataObj.image;

  const profilePhoto = image;

  // const userID = newUserData.newUser._id;

  const [isLoading, setIsLoading] = useState(false);
  const [isLoading3, setIsLoading3] = useState(false);
  const [buttonActive, setButtonActive] = useState(true);

  const navigate = useNavigation();

  // useEffect(() => {
  //     if (Object.keys(namesObjData).length > 0) {
  //         submitUser_to_db()
  //     }
  // }, [namesObjData]);

  useEffect(() => {
    //console.log("Username", username)
  }, [username]);

  // Debounce the searchQuery
  useEffect(() => {
    if (!searchQuery) {
      setSearchQueryDebounced("");
      setIsTyping(false);
      return;
    }

    setIsTyping(true);

    const timer = setTimeout(() => {
      setSearchQueryDebounced(searchQuery);
      setIsTyping(false);
    }, 300); // 300ms debounce time

    return () => clearTimeout(timer); // Clear timer on unmount or searchQuery change
  }, [searchQuery]);

  const handleUsername = (text) => {
    setUsername(text.toLowerCase());
    checkUsernameExists(text.toLowerCase());
  };
  const handleDisplayname = (text) => {
    setDisplayname(text);
  };

  const { isLoading: isLoadingSearch, data } = useQuery({
    queryKey: ["searchQuery", searchQueryDebounced],
    //queryKey: ['searchQuery', searchQuery],
    queryFn: async () => {
      if (!searchQueryDebounced) return null; // Prevent unnecessary requests
      const username = searchQueryDebounced.toLowerCase();
      const response = await axios.get(`/newUser/${username}`);
      if (response.data.exists) {
        //console.log('we are loop A')
        setIsUsernameValid(false);
        //setButtonActive(false)
        setErrorMessage("Username already exists. Please use a different one.");
      } else {
        //console.log('we are loop B')
        setIsUsernameValid(true);
        setErrorMessage("");
        //  setButtonActive(true)
      }
      return response.data;
    },
    enabled: !!searchQueryDebounced, // Run query only when searchQuery exists
    //enabled: !!searchQuery, // Run query only when searchQuery exists
  });

  const handleSignUpUsernames = (text) => {
    if (isLoadingSearch) {
      //console.log('Still checking username, please wait...');
      return;
    }
    formValidation2();
  };

  // Ensure the button is only active when the username is valid
  useEffect(() => {
    //console.log('isUsernameValid', isUsernameValid);

    if (data) {
      setButtonActive(data.exists); // Button active only if username doesn't exist
    }
  }, [data, isUsernameValid]);

  useEffect(() => {
    if (data) {
      //console.log('data.exists', data.exists);
    }
  }, [data]);

  const handleCloseModal = () => {
    setIsSuccessAlertCompVisible(false);
    //navigate.replace('log_in');
    // navigate.push('log_in')
    navigate.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{ name: "log_in" }],
      })
    );
  };
  const formValidation2 = async () => {
    const username = searchQuery.toLowerCase();
    //console.log('heyreeeeeeeeeeeeeee')
    //Validating all forms
    if (username === "") {
      setIsUsernameFocused(true);
      // } else if (displayname === '') {
      //     setIsDisplaynameFocused(true)
    } else {
      //console.log("They all cool except Picture for now")
      const response = await axios.get(`/newUser/${username}`);
      if (response.data.exists) {
        //console.log('we are loop AB')
        setIsUsernameValid(false);
        //setButtonActive(false)
        setErrorMessage("Username already exists. Please use a different one.");
      } else {
        // setNamesObjData(namesObj)
        const namesObj = { username, displayname };
        //  const userDataObj_v2 = { ...userDataObj, ...namesObj }

        try {
          const userDataObject = { ...userDataObj, ...namesObj };

          //console.log("namesObj", namesObj)
          //console.log('userDataObject', userDataObject)

          const userDataJSON = JSON.stringify(userDataObject);

          const formData = new FormData();
          formData.append("userDataJSON", userDataJSON);

          //console.log('userDataJSON', userDataJSON)
          // navigate.push('my_city_state', { userDataObj_v2 })

          // Append Profile Photo separately
          if (profilePhoto) {
            const uriParts = profilePhoto.split(".");
            const fileType = uriParts[uriParts.length - 1];

            formData.append("profilePhoto", {
              uri: Platform.OS === "ios" ? profilePhoto.replace("file://", "") : profilePhoto,
              type: `image/${fileType}`,
              name: "profilePhoto", // Ensure a unique name
            });
          }

          setIsLoading3(true);

          const response = await axios.post("/create_new_user/create_new_user", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

          if (response.status === 200 || response.status === 201) {
            //console.log('response.data.message', response.data.message)
            // //console.log('response.data.message', response.data.message)
            await AsyncStorage.setItem("hasAccount", "true");
            setSuccessMessage(response.data.message ? response.data.message : "Sign up successful");
            //userDataObj = {};
            setUsername("");
            setDisplayname("");
            setSearchQuery("");
            setSearchQueryDebounced("");
            setIsSuccessAlertCompVisible(true);
          } else {
            setErrorMessage2("Unexpected response");
            setIsErrorCompVisible(true);
          }
        } catch (error) {
          if (error.response) {
            //console.log('ERROR', error.response)
            setErrorMessage2(
              error.response.data.message
                ? error.response.data.message
                : "SignUp Error please try again letter! "
            );
            setIsErrorCompVisible(true);
          } else if (error.request) {
            setErrorMessage2("No response Recieved");
            setIsErrorCompVisible(true);
          } else {
            setErrorMessage2(
              error.message ? error.message : "Signup error, please try again letter !"
            );
            setIsErrorCompVisible(true);
          }
        } finally {
          setIsLoading3(false);
        }
      }
    }
  };

  // if (isLoading) {
  //     return (
  //         <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
  //             <ActivityIndicator size={'large'} />
  //         </View>
  //     )
  // }

  return (
    <View style={styles.createPullFormContainer}>
      <TouchableOpacity
        // onPress={() => navigate.push('sign_in')}
        onPress={() => navigate.goBack()}
      >
        <BackArrow color={Colours.DARKGRAY} />
      </TouchableOpacity>
      <View style={styles.profilePhotoContainer}>
        {image ? (
          <Image
            source={{ uri: image }}
            style={[styles.userImage, { backgroundColor: "#d6d4d4ff" }]}
            contentFit="cover"
            cachePolicy="disk"
          />
        ) : (
          <Image
            source={require("../../../assets/profile_image_holder.jpg")}
            style={styles.userImage}
          />
        )}
      </View>
      <View style={styles.textAndTxtInput}>
        <Text
          style={{
            color: Colours.DARKGRAY,
            fontSize: dynamicFontSize(12),
            fontFamily: "Sen-Regular",
          }}
        >
          USERNAME
        </Text>
        <AppTextInput
          style={[styles.textInputStyle, isUsernameFocused && styles.focusedBorder]}
          placeholder="username - in lowercase"
          fontSize={15}
          // keyboardType="email-address"
          //autoCapitalize='none'
          value={searchQuery}
          onFocus={() => setIsUsernameFocused(true)}
          onBlur={() => setIsUsernameFocused(false)}
          // onChangeText={(text) => setSearchQuery(text.replace(/[^a-z_]/g, ''))}
          onChangeText={(text) =>
            setSearchQuery(
              text
                .trim()
                .toLowerCase()
                .replace(/[^a-z0-9_]/g, "")
            )
          }

          // onChangeText={(text) => handleUsername(text.toLowerCase())}
          // />{isLoading3 ? (
        />
        {isLoadingSearch ? (
          <View
            style={{
              display: "flex",
              height: dynamicSize(20),
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ActivityIndicator size={"small"} />
          </View>
        ) : (
          !isUsernameValid && <Text style={{ color: "red" }}>{errorMessage}</Text>
        )}
      </View>
      {/* <View style={styles.textAndTxtInput}>
                <Text style={{ color: Colours.DARKGRAY, fontSize: dynamicFontSize(12), fontFamily: 'Sen-Regular' }}>
                    SET YOUR DISPLAY-NAME
                </Text>
                <TextInput style={[styles.textInputStyle, isDisplaynameFocused && styles.focusedBorder,]}
                    placeholder='Display name'
                    fontSize={15}
                    //secureTextEntry={true}
                    // secureTextEntry={showPassword ? false : true} // Make it a password input

                    onFocus={() => setIsDisplaynameFocused(true)}
                    onBlur={() => setIsDisplaynameFocused(false)}
                    onChangeText={handleDisplayname}

                // rightButton={<Icon name={showPassword ? 'eye-off' : 'eye'} onPress={() => setShowPassword(!showPassword)} />}

                />
            </View> */}
      <TouchableOpacity
        style={[
          styles.buttonGray,
          { backgroundColor: buttonActive ? Colours.PRIMARY_LIGHT : Colours.PRIMARY },
        ]}
        // { backgroundColor: !isLoadingSearch && isUsernameValid ? Colours.PRIMARY_LIGHT : Colours.PRIMARY }]}
        onPress={() => handleSignUpUsernames()}
        disabled={buttonActive}
        // disabled={isLoadingSearch || !isUsernameValid}
      >
        {isLoading3 ? (
          <ActivityIndicator size="small" color="white" />
        ) : (
          <Text style={{ color: "white", fontSize: dynamicFontSize(15), fontFamily: "Sen-Bold" }}>
            Complete signup
          </Text>
        )}
      </TouchableOpacity>

      <Modal visible={isSuccessAlertCompVisible} transparent={true} animationType="fade">
        <SuccessAlertComp message={successMessage} onClose={handleCloseModal} />
      </Modal>
      <Modal
        visible={isErrorCompVisible}
        transparent={true}
        animationType="fade"
        onRequestClose={() => setIsErrorCompVisible(false)}
      >
        <ErrorAlertComp message={errorMessage2} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>
      {/* <Toast config={toastConfig} /> */}
    </View>
  );
};

const styles = StyleSheet.create({
  createPullFormContainer: {
    flex: 1, // Use flex: 1 to fill the screen
    paddingTop: dynamicSpacing(100),
    padding: dynamicSpacing(15),
    backgroundColor: "white",
  },
  textAndTxtInputRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: dynamicSpacing(15),
  },
  textAndTxtInput: {
    marginTop: dynamicSpacing(15),
  },
  textInputStyle: {
    height: dynamicSpacing(50),
    marginTop: dynamicSpacing(10),
    padding: dynamicSpacing(15),
    borderWidth: dynamicSize(1.5),
    borderColor: Colours.DARKLIGHTGRAY,
    borderRadius: dynamicSize(7),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(12),
  },
  focusedBorder: {
    borderColor: Colours.PRIMARY,
  },
  buttonGray: {
    alignItems: "center",
    justifyContent: "center",
    borderRadius: dynamicSize(15),
    marginTop: dynamicSpacing(25),
    height: dynamicSpacing(60),
  },
  profilePhotoContainer: {
    justifyContent: "center",
    alignItems: "center",
    marginBottom: dynamicSpacing(10),
  },
  userImage: {
    width: dynamicSize(100),
    height: dynamicSize(100),
    borderRadius: dynamicSize(99),
    marginBottom: dynamicSpacing(3),
    borderWidth: dynamicSize(1.5),
    borderColor: Colours.PRIMARY,
    marginTop: dynamicSpacing(10),
    backgroundColor: Colours.LIGHTGRAY,
  },
});

export default UsernameDisplaynameScreen;
